import { c as _c } from "react/compiler-runtime";
import { AnalyticsFeatureViewed } from '@cc-shopping/platform-analytics/AnalyticsFeatureViewed';
import { theme } from '@cc-shopping/ui/theme';
import Box from '@mui/material/Box';
import { COLORS_MAP } from '../../constants';
import type { StructuredContentDocumentWithRenderer } from '../../hydration/types';
import { renderStructuredContent } from '../../renderContext';
import type { ColorToken } from '../../types';
import { CSS_VARIABLES as COLUMN_CSS_VARIABLES } from '../Columns/Column';
import { CSS_VARIABLES as WELL_CSS_VARIABLES } from '../Well';
const wellBorderRadius = theme.spacing(2);
type NWVerifiedContainerProps = StructuredContentDocumentWithRenderer<{
  backgroundColor?: ColorToken;
}>;
export const NWVerifiedContainer = t0 => {
  const $ = _c(12);
  const {
    props
  } = t0;
  let t1;
  if ($[0] !== props) {
    t1 = props ?? {};
    $[0] = props;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    children,
    backgroundColor: t2
  } = t1;
  const backgroundColor = t2 === undefined ? "neutral-lightest" : t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      xs: 12,
      md: "unset"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = COLORS_MAP[backgroundColor] ?? backgroundColor;
  let t5;
  let t6;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      xs: 3,
      md: 3.5,
      xl: "2rem"
    };
    t6 = {
      color: "greens.main"
    };
    $[3] = t5;
    $[4] = t6;
  } else {
    t5 = $[3];
    t6 = $[4];
  }
  let t7;
  if ($[5] !== t4) {
    t7 = {
      [WELL_CSS_VARIABLES.borderRadius]: wellBorderRadius,
      [COLUMN_CSS_VARIABLES.gridColumnEnd]: t3,
      backgroundColor: t4,
      position: "relative",
      borderRadius: 3,
      padding: t5,
      "& h2:first-of-type": t6
    };
    $[5] = t4;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== children) {
    t8 = renderStructuredContent(children);
    $[7] = children;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t7 || $[10] !== t8) {
    t9 = <AnalyticsFeatureViewed entityName="nw_verified_container"><Box sx={t7}>{t8}</Box></AnalyticsFeatureViewed>;
    $[9] = t7;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  return t9;
};